import {
  Container,
  Row,
  Col,
  Select,
  Option,
  Title
} from '@qonsoll/react-design'
import PropTypes from 'prop-types'
import { useTranslations } from 'contexts/Translation'
import { useGetApplications } from 'domains/Application/hooks'
import { getId } from 'services/firestore'
import { useMemo } from 'react'
import _ from 'lodash'

// Takes a value of type object and onChange function
// Returns selected option object
const ApplicationSelect = (props) => {
  const {
    value,
    onChange,
    showTitle = true,
    allowClear = true,
    exclude = [],
    ...rest
  } = props

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const [allApplications = [], loading] = useGetApplications({
    orderBy: 'name'
  })

  // [COMPUTED_PROPERTIES]
  // Handling case when db record not added yet but value already exists and ready to be used
  const valueComputed = useMemo(
    () =>
      value
        ? { ...(value || []), _id: value._id || getId('Applications') }
        : null,
    [value]
  )
  const optionsComputed = useMemo(() => {
    const _options = valueComputed
      ? _.uniqBy([...allApplications, valueComputed], '_id')
      : allApplications
    const filteredOptions = _options.filter((o) => !exclude.includes(o._id))
    return filteredOptions
  }, [allApplications, valueComputed, exclude])

  // [HANDLERS]
  const handleChange = (_id) => {
    const selected = optionsComputed.find(({ _id: id }) => id === _id)
    onChange?.(selected || null)
  }

  return (
    <Container my={4} {...rest}>
      {showTitle && (
        <Title mb={2} level={4}>
          {t('Application')}
        </Title>
      )}
      <Row noGutters>
        <Col>
          <Select
            allowClear={allowClear}
            loading={loading}
            placeholder={t('Please, select application')}
            value={valueComputed?._id}
            onChange={handleChange}>
            {optionsComputed.map((application) => (
              <Option key={application?._id} value={application?._id}>
                {application?.name}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
    </Container>
  )
}

ApplicationSelect.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  showTitle: PropTypes.bool,
  allowClear: PropTypes.bool,
  exclude: PropTypes.array
}

export default ApplicationSelect
